import React from 'react';
import {useSelector} from 'react-redux';
import RimacLogo from '../RimacLogo';
import {Link, useLocation} from 'react-router-dom';
import HeaderProfile from './../HeaderProfile';
import {inicioRoute} from '../../../utils/helpers';

const Header = () => {
  const { canalActual, configuracion } = useSelector((state) => state.auth);

  const activeMenuClassName = 'header__menu_option active';
  const { pathname } = useLocation();

  return (
    <header className="container-fluid header">
      <div className="container header__wrapper">
        <div className="header__left">
          <RimacLogo fill="#FFFFFF" />
          <h2 className="header__secction">{canalActual}</h2>
        </div>
        <div className="header__right">
          <div title="Inicio" className="elements-inline nomargin">
            <Link to={inicioRoute()} className={pathname === inicioRoute() ? activeMenuClassName : 'header__menu_option'}>
              Inicio
            </Link>
            {configuracion.MENU.ventasUrl ? (
              <Link to={{ pathname: configuracion.MENU.ventasUrl }} className='header__menu_option' target='_blank'>
                Ventas
              </Link>
            ) : null}
          </div>
          <HeaderProfile />
        </div>
      </div>
    </header>
  );
};

export default Header;
